import * as React from "react";
import { RouteComponentProps, Route, Switch, Link } from "react-router-dom";
import {
	Container,
	Grid,
	Segment,
	Loader,
	Button,
	Icon
} from "semantic-ui-react";

import { firebaseDB } from "../firebase";
import SubQuadNavigation from "../components/SubQuadNavigation";
import RouteWithSubRoutes from "../components/RouteWithSubRoutes";
import StaticDataProvider, {
	withStaticData,
	StaticDataProps
} from "../helpers/StaticDataProvider";
import QuadrantProvider, {
	withQuadrants,
	QuadrantProps
} from "../helpers/QuadrantProvider";
import Markdown from "../components/WrappedMarkdown";

export type RouteParams = null;
export interface OwnProps
	extends RouteComponentProps<RouteParams>,
		QuadrantProps,
		StaticDataProps {
	infoKey: "owners" | "strategy" | "marketing" | "operations";
	routes: any[];
}

export interface State {}

class QuadPage extends React.Component<OwnProps, State> {
	state = {};

	render() {
		console.log(this.props);
		if (!this.props.isLoaded)
			return <Loader size="large" active indeterminate />;
		return (
			<Container>
				<Container text>
					<Markdown
						source={
							this.props.staticdata[this.props.infoKey] &&
							this.props.staticdata[this.props.infoKey]
								.description
						}
					/>
				</Container>
				<Container text>
					<Button
						color={"black"}
						style={{
							margin: "24px auto",
							display: "block"
						}}
						onClick={() =>
							this.props.history.push(
								this.props.infoKey + "/overview"
							)
						}
						icon
						labelPosition="left"
					>
						<Icon name="pencil" />
						Write an Overview
					</Button>
				</Container>

				<Container text style={{ marginTop: 24, marginBottom: 24 }}>
					<SubQuadNavigation
						data={(
							this.props.staticdata[this.props.infoKey]
								.quadrantOrder || []
						).map(
							id =>
								typeof id === "string"
									? this.props.quadrants[id]
									: id
						)}
						navigate={this.props.history.push}
						curPath={this.props.location}
					/>
				</Container>
			</Container>
		);
	}
}

export default withQuadrants(withStaticData(QuadPage));



// WEBPACK FOOTER //
// ./src/pages/QuadPage.tsx